module.exports = __webpack_public_path__ + "assets/images/ctc52f8771edabf3134544c41744797a133.svg";